import { logUsage } from 'owa-analytics';
import { launchCalendarFullCompose } from 'owa-calendar-forms-launch-handlers';
import { getActionSourceFromCommandingViewMode } from 'owa-command-ribbon';
import { lazyShowInsertLinkDialog } from 'owa-compose-ribbon';
import { owaDate } from 'owa-datetime';
import { InsertLinkSource } from 'owa-editor-ribbonplugin/lib/types/InsertLinkSource';
import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import initializeYammerPublisher from 'owa-mail-commands/lib/actions/initializeYammerPublisher';
import onArchive from 'owa-mail-commands/lib/actions/onArchive';
import onBlock from 'owa-mail-commands/lib/actions/onBlock';
import onClearMsgPermissions from 'owa-mail-commands/lib/actions/onClearMsgPermissions';
import onCreateRule from 'owa-mail-commands/lib/actions/onCreateRule';
import onDelete from 'owa-mail-commands/lib/actions/onDelete';
import { launchPMEFromExternal } from 'owa-cortana-pme';
import { onFlagUnflag } from 'owa-mail-commands/lib/actions/onFlagUnflag';
import onIgnoreStopIgnore from 'owa-mail-commands/lib/actions/onIgnoreStopIgnore';
import onJunkNotJunk from 'owa-mail-commands/lib/actions/onJunkNotJunk';
import onMarkAsPhishing from 'owa-mail-commands/lib/actions/onMarkAsPhishing';
import onMarkAsReadUnread from 'owa-mail-commands/lib/actions/onMarkAsReadUnread';
import onNewYammerPost from 'owa-mail-commands/lib/actions/onNewYammerPost';
import onPinUnpin from 'owa-mail-commands/lib/actions/onPinUnpin';
import onPrint from 'owa-mail-commands/lib/actions/onPrint';
import onSensitivity from 'owa-mail-commands/lib/actions/onSensitivity';
import onShowInImmersiveReader from 'owa-mail-commands/lib/actions/onShowInImmersiveReader';
import onSnooze from 'owa-mail-commands/lib/actions/onSnooze';
import onSweep from 'owa-mail-commands/lib/actions/onSweep';
import onToggleMessageClassification from 'owa-mail-commands/lib/actions/onToggleMessageClassification';
import onToggleRmsTemplate from 'owa-mail-commands/lib/actions/onToggleRmsTemplate';
import onUndo from 'owa-mail-commands/lib/actions/onUndo';
import { save } from 'owa-mail-compose-command';
import { MenuItemType } from 'owa-filterable-menu';
import { getMailMenuItemShouldShowMap } from 'owa-mail-filterable-menu-behavior';
import { lazyToggleFolderPaneExpansion } from 'owa-mail-layout';
import checkAndCreateNewMessage from 'owa-mail-message-actions/lib/actions/checkAndCreateNewMessage';
import { lazyOnOpenCustomizer } from 'owa-mail-ribbon-customizer';
import { lazyCreateNewNote, lazyDeleteNote, lazyViewEmailFromNote } from 'owa-notes-store';
import { RecipientType } from 'owa-recipient-types/lib/types/RecipientType';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import { lazySelfMountGALDialog } from 'owa-recipient-well-label';
import type { OwaDate } from 'owa-datetime';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import {
    onReply,
    onReplyAll,
    onReplyWithMeeting,
    onForward,
    onForwardAsAttachment,
} from 'owa-mail-commands/lib/actions/onResponse';
import type FlagType from 'owa-service/lib/contract/FlagType';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type CLPLabel from 'owa-mail-protection-types/lib/schema/CLPLabel';
import type MessageClassificationType from 'owa-service/lib/contract/MessageClassificationType';
import { lazyToggleExpressionPane } from 'owa-expressions-view';
import { RIBBON_OPENED_SOURCE } from 'owa-expressions-store/lib/store/schema/ExpressionPickerOpenedSource';
import isExpressionPaneOpen from 'owa-expressions-store/lib/utils/isExpressionPaneOpen';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { isGroupSelected } from 'owa-group-utils';
import { getGroupsStore } from 'owa-groups-shared-store/lib/GroupsStore';
import { getCurrentGroupInformationStore } from 'owa-groups-shared-store/lib/CurrentGroupInformationStore';
import { lazyOpenRulesPanelInModal } from 'owa-groups-inbox-rules-option';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { saveConversationsOptionQuick } from 'owa-conversations-option';
import { onMessagePreviewToggle } from 'owa-message-preview-option/lib/actions/saveMessagePreviewOption';
import { lazySaveReadingPaneOption } from 'owa-reading-pane-option';
import { saveDensityOption } from 'owa-display-density-option';
import type DisplayDensityMode from 'owa-service/lib/contract/DisplayDensityMode';
import type { ClientItemId } from 'owa-client-ids';
import {
    lazyDeleteItems,
    lazyMarkItemJunkNotJunkFromReadingPane,
    lazyMarkItemAsPhishingFromReadingPane,
    lazyBlockLastSenderFromReadingPane,
} from 'owa-mail-triage-action';
import { closeDeeplinkReadingPane } from 'owa-mail-actions/lib/readingPaneActions';
import getDefaultDisposalType from 'owa-mail-reading-pane-store/lib/utils/getDefaultDisposalType';
import { lazyCreateRuleFromItem } from 'owa-mail-inbox-rules';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import {
    getSelectedTableView,
    shouldSuppressServerMarkReadOnReplyOrForward,
} from 'owa-mail-list-store';
import { lazyMarkItemAsReadFromReadingPane } from 'owa-mail-mark-read-actions';
import type Message from 'owa-service/lib/contract/Message';
import {
    lazyForwardItem,
    lazyReplyToItem,
    lazyForwardItemAsAttachment,
} from 'owa-mail-message-actions';
import print from 'owa-mail-reading-pane-store/lib/actions/print';
import { onShowInImmersiveReader as onShowInImmersiveReaderSingleItem } from 'owa-immersive-reader-store/lib/utils/onShowInImmersiveReader';
import { lazyReplyByMeeting } from 'owa-mail-reading-pane-store';
import { MailRibbonTabId } from 'owa-ribbon-ids';

export const onNewEvent = () => {
    launchCalendarFullCompose({
        fullComposeEntrySource: 'Mail_NewItems_EventButton',
    });
};

export const onToggleFolderPane = () => {
    lazyToggleFolderPaneExpansion.importAndExecute();
};

export const onNewMessage = () => {
    checkAndCreateNewMessage(getActionSourceFromCommandingViewMode(), null /* targetId */);
};

export const onShowInImmersiveReaderClicked = (
    itemId?: ClientItemId,
    targetWindow?: Window
) => () => {
    const actionSource = getActionSourceFromCommandingViewMode();
    if (itemId) {
        onShowInImmersiveReaderSingleItem(
            itemId /* itemId */,
            actionSource,
            undefined,
            targetWindow
        );
    } else {
        onShowInImmersiveReader(actionSource);
    }
};

export const onPrintClicked = (itemId?: ClientItemId, targetWindow?: Window) => () => {
    const actionSource = getActionSourceFromCommandingViewMode();
    if (itemId) {
        print(
            {
                mailboxInfo: itemId.mailboxInfo,
                Id: itemId.Id,
            },
            actionSource,
            targetWindow
        );
    } else {
        onPrint(actionSource);
    }
};

export const onDeleteClicked = (itemId?: ClientItemId, targetWindow?: Window) => () => {
    if (itemId) {
        lazyDeleteItems.import().then(deleteItems => {
            deleteItems(
                [itemId.Id],
                getDefaultDisposalType(itemId.Id),
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2345 (346,17): Argument of type 'null' is not assignable to parameter of type 'InstrumentationContext[]'.
                // @ts-expect-error
                null,
                getActionSourceFromCommandingViewMode(),
                itemId.mailboxInfo,
                undefined /* disableResetFocus */,
                targetWindow
            ).then(() => {
                closeDeeplinkReadingPane();
            });
        });
    } else {
        onDelete(
            getActionSourceFromCommandingViewMode() /* actionSourceMailStore */,
            getActionSourceFromCommandingViewMode() /* actionSourceAnalyticsActions */,
            undefined /* isExplicitSoftDelete */,
            targetWindow
        );
    }
};

export const onArchiveClicked = () => {
    onArchive(getActionSourceFromCommandingViewMode());
};

export const onMarkAsReadUnreadClicked = (itemId?: ClientItemId) => () => {
    const actionSource = getActionSourceFromCommandingViewMode();
    if (itemId) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (85,13): Type 'ClientItem | undefined' is not assignable to type 'Message'.
        // @ts-expect-error
        const item: Message = getMailStore().items.get(itemId.Id);
        lazyMarkItemAsReadFromReadingPane.importAndExecute(
            itemId.Id,
            getSelectedTableView(),
            !item?.IsRead /* isReadValue */,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (416,13): Argument of type 'null' is not assignable to parameter of type 'InstrumentationContext[]'.
            // @ts-expect-error
            null,
            actionSource
        );
    } else {
        onMarkAsReadUnread(actionSource);
    }
};

export const onReplyWithMeetingClicked = (itemId?: ClientItemId) => () => {
    const actionSource = getActionSourceFromCommandingViewMode();
    if (itemId) {
        lazyReplyByMeeting.importAndExecute(
            itemId.Id,
            undefined /*calendarInlineComposeViewState*/,
            actionSource
        );
    } else {
        onReplyWithMeeting(actionSource);
    }
};

export const onPinUnpinClicked = () => {
    onPinUnpin(getActionSourceFromCommandingViewMode());
};

export const onSaveDraft = (viewState: ComposeViewState) => {
    // Other methods of save have their own logging pipeline with which it would be difficult to merge
    logUsage('SaveDraft', {
        actionSource: getActionSourceFromCommandingViewMode(),
    });
    save(viewState);
};

export const onSensitivityClicked = (
    label: CLPLabel,
    viewState: ComposeViewState,
    targetWindow: Window
) => {
    onSensitivity(viewState, label, targetWindow);
};

export const onSweepClicked = () => {
    onSweep();
};

export const onSnoozeClicked = (date?: OwaDate) => {
    onSnooze(date, getActionSourceFromCommandingViewMode());
};

export const onFlagUnflagClicked = (
    flagType?: FlagType,
    override?: boolean,
    itemId?: ClientItemId
) => () => {
    onFlagUnflag(getActionSourceFromCommandingViewMode(), flagType, override, itemId);
};

export const onReplyClicked = (itemId?: ClientItemId, targetWindow?: Window) => () => {
    const actionSource = getActionSourceFromCommandingViewMode();
    if (itemId) {
        lazyReplyToItem.importAndExecute(
            itemId,
            false /** isReplyAll */,
            actionSource,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (321,13): Argument of type 'null' is not assignable to parameter of type 'InstrumentationContext[]'.
            // @ts-expect-error
            null,
            shouldSuppressServerMarkReadOnReplyOrForward(getSelectedTableView()),
            targetWindow
        );
    } else {
        onReply(actionSource);
    }
};

export const onReplyAllClicked = (itemId?: ClientItemId, targetWindow?: Window) => () => {
    const actionSource = getActionSourceFromCommandingViewMode();
    if (itemId) {
        lazyReplyToItem.importAndExecute(
            itemId,
            true /** isReplyAll */,
            actionSource,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (321,13): Argument of type 'null' is not assignable to parameter of type 'InstrumentationContext[]'.
            // @ts-expect-error
            null,
            shouldSuppressServerMarkReadOnReplyOrForward(getSelectedTableView()),
            targetWindow
        );
    } else {
        onReplyAll(actionSource);
    }
};

export const onForwardClicked = (itemId?: ClientItemId, targetWindow?: Window) => () => {
    const actionSource = getActionSourceFromCommandingViewMode();
    if (itemId) {
        lazyForwardItem.importAndExecute(
            itemId,
            actionSource,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (333,13): Argument of type 'null' is not assignable to parameter of type 'InstrumentationContext[]'.
            // @ts-expect-error
            null,
            shouldSuppressServerMarkReadOnReplyOrForward(getSelectedTableView()),
            targetWindow
        );
    } else {
        onForward(actionSource);
    }
};

export const onUndoClicked = () => {
    onUndo(getActionSourceFromCommandingViewMode());
};

export const onForwardEmailAsAttachmentClicked = (
    itemId?: ClientItemId,
    targetWindow?: Window
) => () => {
    const actionSource = getActionSourceFromCommandingViewMode();
    if (itemId) {
        lazyForwardItemAsAttachment.importAndExecute(itemId, actionSource, targetWindow);
    } else {
        onForwardAsAttachment(actionSource);
    }
};

export const onPMEClicked = (tabId: MailRibbonTabId) => () => {
    if (tabId === MailRibbonTabId.Tab_Home) {
        launchPMEFromExternal.importAndExecute('MailRibbon-home');
    }
};

export const onIgnoreStopIgnoreClicked = () => {
    const shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
    onIgnoreStopIgnore(
        getActionSourceFromCommandingViewMode(),
        shouldShowBehaviorMap[MenuItemType.Ignore]()
    );
};

export const onJunkNotJunkClicked = (itemId?: ClientItemId, targetWindow?: Window) => () => {
    const actionSource = getActionSourceFromCommandingViewMode();
    if (itemId) {
        lazyMarkItemJunkNotJunkFromReadingPane
            .importAndExecute(
                itemId.Id,
                getSelectedTableView(),
                actionSource,
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2345 (363,17): Argument of type 'null' is not assignable to parameter of type 'InstrumentationContext[]'.
                // @ts-expect-error
                null /*instrumentationContext*/,
                targetWindow
            )
            .then(() => {
                closeDeeplinkReadingPane();
            });
    } else {
        const shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
        onJunkNotJunk(actionSource, shouldShowBehaviorMap[MenuItemType.MarkAsJunk]());
    }
};

export const onMarkAsPhishingClicked = (itemId?: ClientItemId, targetWindow?: Window) => () => {
    const actionSource = getActionSourceFromCommandingViewMode();
    if (itemId) {
        lazyMarkItemAsPhishingFromReadingPane
            .importAndExecute(
                itemId.Id,
                getSelectedTableView(),
                actionSource,
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2345 (379,17): Argument of type 'Window | undefined' is not assignable to parameter of type 'Window'.
                // @ts-expect-error
                targetWindow
            )
            .then(() => {
                closeDeeplinkReadingPane();
            });
    } else {
        onMarkAsPhishing(actionSource);
    }
};

export const onBlockClicked = (itemId?: ClientItemId, targetWindow?: Window) => () => {
    const actionSource = getActionSourceFromCommandingViewMode();
    if (itemId) {
        lazyBlockLastSenderFromReadingPane.importAndExecute(
            itemId.Id,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (391,13): Argument of type 'null' is not assignable to parameter of type 'InstrumentationContext[]'.
            // @ts-expect-error
            null /*instrumentationContexts*/,
            actionSource,
            targetWindow
        );
    } else {
        onBlock(actionSource);
    }
};

export const onCreateRuleClicked = (targetWindow?: Window, itemId?: ClientItemId) => () => {
    const source = getActionSourceFromCommandingViewMode();
    if (itemId) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (85,13): Type 'ClientItem | undefined' is not assignable to type 'Message'.
        // @ts-expect-error
        const item: Message = getMailStore().items.get(itemId.Id);
        lazyCreateRuleFromItem.import().then(createRuleFromItem => {
            createRuleFromItem(item, source, targetWindow);
        });
    } else {
        onCreateRule(source);
    }
};

export const onManageRulesClicked = (targetWindow?: Window) => (): void => {
    if (isFeatureEnabled('grp-loadFolders') && isGroupSelected()) {
        const groupsStore = getGroupsStore();
        const group = groupsStore?.groups?.get(getCurrentGroupInformationStore().smtpAddress);
        const groupName = group?.basicInformation?.DisplayName;

        if (groupName) {
            lazyOpenRulesPanelInModal.importAndExecute(groupName);
        }
    } else {
        lazyMountAndShowFullOptions.importAndExecute('mail', 'rules', undefined, targetWindow);
    }
};

export const onClearMsgPermissionsClicked = (viewState: ComposeViewState) => {
    onClearMsgPermissions(viewState);
};

export const onNewEmailSplitButtonExecuted = () => {
    if (isFeatureEnabled('tri-newYammerPostButton')) {
        initializeYammerPublisher();
        logUsage('YammerPublisher_MenuItemSeen');
    }
};

export const onNewYammerPostClicked = () => {
    onNewYammerPost();
};

export const onToggleMessageClassificationClicked = (
    viewState: ComposeViewState,
    classification: MessageClassificationType
) => {
    onToggleMessageClassification(viewState, classification);
};

export const onToggleRmsTemplateClicked = (
    viewState: ComposeViewState,
    RmsTemplateId: string,
    targetWindow: Window
) => {
    onToggleRmsTemplate(viewState, RmsTemplateId, targetWindow);
};

export const onRibbonCustomizerClicked = () => {
    lazyOnOpenCustomizer.importAndExecute();
};
export const onShowLinkDialogClicked = (viewState: ComposeViewState, targetWindow: Window) => {
    lazyShowInsertLinkDialog
        .import()
        .then(showInsertLinkDialog =>
            showInsertLinkDialog(
                viewState as EditorViewState,
                targetWindow,
                InsertLinkSource.OriginalRibbon,
                owaDate()
            )
        );
};

export const onEmojisButtonClicked = (
    viewState: ComposeViewState | undefined,
    targetWindow: Window
) => {
    if (viewState) {
        const shouldShowExpressionPane = !isExpressionPaneOpen(viewState.expressionId!);
        lazyToggleExpressionPane.import().then(toggleExpressionPane => {
            toggleExpressionPane(
                shouldShowExpressionPane,
                true /*useFlexPane*/,
                RIBBON_OPENED_SOURCE,
                viewState,
                viewState.expressionId,
                targetWindow
            );
        });
    }
};

export const onNewNoteClicked = () => {
    lazyCreateNewNote.importAndExecute('NotesFolder');
};

export const onAddressButtonClicked = (
    viewState: RecipientWellWithFindControlViewState,
    targetWindow: Window
) => {
    let recipientType: RecipientType = RecipientType.To; // TODO: Once the new design of the GAL pop up we should figure out how to address the To and Cc options

    lazySelfMountGALDialog
        .import()
        .then(selfMountGALDialog => selfMountGALDialog({ viewState, recipientType, targetWindow }));
};

export const onPollButtonClicked = () => {};

export const onDeleteNoteClicked = () => {
    lazyDeleteNote.importAndExecute('NotesFolder');
};

export const onViewEmailFromNoteClicked = () => {
    lazyViewEmailFromNote.importAndExecute('NotesFolder');
};

export const onViewSettingsClicked = () => {
    lazyMountAndShowFullOptions.importAndExecute('mail', 'layout');
};

export const onConversationModeClicked = (listType: ReactListViewType) => {
    saveConversationsOptionQuick(listType);
};

export const onMessagePreviewClicked = (selected: boolean) => {
    onMessagePreviewToggle(selected);
};

export const onReadingPanePositionClicked = (readingPanePosition: number) => {
    lazySaveReadingPaneOption.importAndExecute(readingPanePosition);
};

export const onDensityClicked = (newDensity: DisplayDensityMode) => {
    saveDensityOption(newDensity);
};
